<div [ngClass]="[(user && user.isCustomer)? 'wall-customer':'', (!hasLoggedIn)? 'signup-bg' : '', (hasLoggedIn && !isChromelessRoute)? theme : '']">
  <div class="expanded row"  [ngClass]="{'signup-container' : !hasLoggedIn, 'chromeless-route': isChromelessRoute}" style="min-height:100vh;">
    <ng-template [ngIf]="user && !user.isCustomer && !isChromelessRoute">
      <div class="tp-firm-sidebar-width">
        <div class="show-for-large sidebar shrink" *ngIf="hasLoggedIn">
          <app-sidebar [isExpanded]="false" *ngIf="user && !user.isCustomer"></app-sidebar>
          <div #appwindows *ngIf="hasLoggedIn">
            <app-windows></app-windows>
          </div>
          <div *ngIf="onboardStatus === 'Done' && subscriptionStatus == 'Paid' && basicPlanLimitLoaded">
            <app-tpiq-chat-bot
              *ngIf="basicPlanLimit?.jaineAllowed || (basicPlanLimitLoadFailed && jaineAllowedOnError)"
              (onJaineEscalation)="showEscalation($event)"></app-tpiq-chat-bot>
            <app-locked-jaine
              *ngIf="basicPlanLimit && !basicPlanLimit.jaineAllowed">
            </app-locked-jaine>
            <button *ngIf="basicPlanLimitLoadFailed && basicPlanLimitRetryVisible" type="button" class="jaine-limit-retry"
                    (click)="retryBasicPlanLimit()">
              jAIne access is unavailable. Retry
            </button>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template [ngIf]="user && user.isCustomer && !isChromelessRoute">
      <div class="tp-customer-sidebar-width">
        <div class="show-for-large small-0 sidebar" *ngIf="hasLoggedIn">
          <app-customer-sidebar [isExpanded]="true" *ngIf="user && user.isCustomer"></app-customer-sidebar>
          <div #appwindows *ngIf="hasLoggedIn">
            <app-windows></app-windows>
          </div>
        </div>
      </div>
    </ng-template>
    <div class="top-bar" data-sticky-container *ngIf="hasLoggedIn && !isChromelessRoute" [ngClass]="titleCSS">
      <div class="top-bar-title">
        <div class="tpiq-off-canvas-menu-buttom hide-for-large float-left" (click)="toggleOffCanvasMenu()">
          <i [ngClass]="{'ion-navicon-round':!isOffCanvasMenuExpanded, 'ion-close-round':isOffCanvasMenuExpanded}"></i>
        </div>
        <div class="icon float-left" style="margin-left: 5px;" (click)="onLogoClick()">
          <!-- <img src="{{smallLogo}}" style="cursor: pointer;border-radius: 5px;" [hidden]="user && user.isCustomer"/> -->
          <img src="{{smallLogo}}" style="border-radius: 5px;" [style.cursor]="logoOpensPicker ? 'pointer' : 'default'"/>

        </div>
        <div class="top-nav-arrows float-left" [hidden]="user && user.isCustomer" #title>
          <div class="top-margin float-left" [hidden]="!displayArrows()"><i class="icon ion-ios-arrow-left" (click)="showPrevious()"></i><i class="icon ion-ios-arrow-right item-disabled" disabled></i></div>
          <div class="top-nav-name pointer float-left" [ngClass]="(pageTitle && pageTitle.length > 50) ? 'ellipsis' : 'none'" [style.left]="displayArrows()? '10px':'10px'"  [innerHtml]="pageTitle" *ngIf = "channelType !== 'companies' && channelType !== 'clients' && channelType !== 'leads'"></div>
        </div>
      </div>
      <div class="top-bar-end" id="responsive-menu" *ngIf="hasLoggedIn">
        <div *ngIf="user && !user.isCustomer">
          <app-header></app-header>
        </div>
        <app-customer-header *ngIf="user && user.isCustomer"></app-customer-header>
      </div>
      <div style="clear: both;"></div>
    </div>
    
    <div class="columns" [ngClass]="(hasLoggedIn && !isChromelessRoute)? mainCanvasCss: ''" [style.padding]="(!hasLoggedIn || isChromelessRoute)? '0' : '0 15px'">

      <div *ngIf="user && user.isCustomer"class="top-nav-arrows page-title-customer mb-2" #title>
        <div class="top-margin " [hidden]="!displayArrows()"><i class="icon ion-ios-arrow-left" (click)="showPrevious()"></i><i class="icon ion-ios-arrow-right item-disabled" disabled></i></div>
        <div class="top-nav-name pointer " [ngClass]="(pageTitle && pageTitle.length > 50) ? 'ellipsis' : 'none'" [style.left]="displayArrows()? '10px':'10px'"  [innerHtml]="pageTitle" *ngIf = "channelType !== 'companies' && channelType !== 'clients' && channelType !== 'leads'"></div>
      </div>

      <router-outlet>
      </router-outlet>
      <router-outlet name="popup">
      </router-outlet>
    </div>
  </div>
</div>

<div id="toast-container" [ngClass]="confirmClass">
  <div class="toast-wrapper" *ngFor="let toast of toasts">
    <div class="toast" [ngClass]="toast.toastClass" *ngIf="toast.toastClass != 'toast-confirm'">
      <div class='toast-title' >{{toast.title}}</div>
      <div class='toast-message' >{{toast.message}}
      </div>
    </div>
    <div class="toast toast-confirm row" style="background-color: #FFFFFF" *ngIf="toast.toastClass == 'toast-confirm'">
      <div class="medium-7 columns">
        <div class='toast-title'>{{toast.message}}</div>
      </div>
      <div class="medium-5 columns btn-wrapper">
        <a class="button success" style="background-color: #0AA8E2;color:#FFFFFF" (click)="confirm($event,toast)">YES</a>
        <a class="button alert" style="background-color: #F06459;color:#FFFFFF" (click)="cancel($event,toast)">NO</a>
      </div>
    </div>
  </div>
</div>

<div class="tpiq-overlay" *ngIf="isOverlay && isLoading"></div>
<div class="tpiq-loading-wheel">
  <div align="center" class="fond" [hidden]="!isLoading">
    <div class="contener_general">
      <div class="contener_mixte"><div class="ballcolor ball_4">&nbsp;</div></div>
      <div class="contener_mixte"><div class="ballcolor ball_3">&nbsp;</div></div>
      <div class="contener_mixte"><div class="ballcolor ball_2">&nbsp;</div></div>
      <div class="contener_mixte"><div class="ballcolor ball_1">&nbsp;</div></div>
    </div>
  </div>
</div>

<app-global-floating-window></app-global-floating-window>
